module.exports = __webpack_public_path__ + "static/media/BizTechFrame1.d3c597b7.png";